<template>
  <el-row>
    <el-row class="mb-3">
      <AssetPeekHeader :asset="asset" />
    </el-row>

    <el-row :gutter="15">
      <el-col :span="8">
        <el-card
          shadow="never"
          header="Events"
        >
          <AssetPeekEvents :asset="asset" />
        </el-card>
      </el-col>

      <el-col :span="16">
        <el-card
          shadow="never"
          header="Attachments"
        >
          <AssetPeekAttachments :asset="asset" />
        </el-card>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
import AssetPeekHeader from '@/components/Application/Manage/Assets/Asset/Peek/Header'
import AssetPeekEvents from '@/components/Application/Manage/Assets/Asset/Peek/Events'
import AssetPeekAttachments from '@/components/Application/Manage/Assets/Asset/Peek/Attachments'

export default {
  components: {
    AssetPeekHeader,
    AssetPeekEvents,
    AssetPeekAttachments
  },
  props: {
    asset: {
      type: Object,
      required: true
    }
  }
}
</script>
